import React, { Component } from 'react';
import Button from '../components/Button';
import FormGroup from '../components/FormGroup';

class Login extends Component {
  state = {
    email: '',
    password: ''
  }

  handleChange = e => {
    const t = e.target;
    this.setState({
      [t.name]: t.value
    });
  }
  handleSubmit = e => {
    this.props.handleLoginSubmit(e, this.state);
  }
  
  render() {
    if( this.props.user !== undefined && this.props.user.id > 0 )
      window.location.href = '/';
    
    const cls = 'login-form',
      form = this.state,
      formSettings = { handleChange: e => this.handleChange(e) };

    return (
      <section className="page-login">
        <div className={cls+'__container bg__logo bg__logo_middle'}>

          <h2 className={cls+'__title page__title'}><span>Авторизация</span></h2>
          <p className={cls+'__description'}>Пройдите авторизацию чтобы войти в систему</p>

          <form className="login-form" onSubmit={ this.handleSubmit }>

            <img src="/assets/imgs/profile-picture.svg" alt="Profile avatar"/>

            <FormGroup type="email" name="email" value={form.email} required placeholder="email" {...formSettings}/>
            <FormGroup type="password" name="password" value={form.password} required placeholder="пароль" {...formSettings}/>

            <div className="loginform__btns">
              <Button theme="success">Войти</Button>
              <a href="login/forget">забыли пароль?</a>
            </div>
          </form>
        </div>
      </section>
    );
  }
}
export default Login;
